import React from 'react';
import { Link } from 'react-router-dom';
import Classes from './Footer.module.css';
import Logo from '../Logo/Logo';
import AutoAwesomeRoundedIcon from '@mui/icons-material/AutoAwesomeRounded';
import VerifiedRoundedIcon from '@mui/icons-material/VerifiedRounded';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';

export default function Footer() {
    return (
        <footer className={Classes.footer}>
            <div className={Classes.topArea}>
                <div className={Classes.leftBlock}>
                    <Link to='/' className={Classes.logoLink}>
                        <Logo alwaysShowText={true} />
                    </Link>

                    <div className={Classes.brandPills}>
                        <span className={Classes.brandPill}>
                            <AutoAwesomeRoundedIcon />
                            DevZona Labs
                        </span>
                        <span className={Classes.verifiedPill}>
                            <VerifiedRoundedIcon />
                            Registered & Incorporated
                        </span>
                    </div>

                    <p className={Classes.brandText}>
                        DevZona delivers Agentic AI systems, LLM products, mobile and web
                        platforms, and scalable cloud infrastructure for global clients.
                    </p>

                    <div className={Classes.ctaRow}>
                        <a href='mailto:hamza@devzona.com'>
                            <EmailRoundedIcon />
                            hamza@devzona.com
                        </a>
                        <a href='https://wa.me/923290992222' target='_blank' rel='noreferrer'>
                            <WhatsAppIcon />
                            WhatsApp Support
                        </a>
                    </div>
                </div>

                <div className={Classes.navColumns}>
                    <div>
                        <h4>Explore</h4>
                        <ul>
                            <li>
                                <Link to='/#about-section'>About</Link>
                            </li>
                            <li>
                                <Link to='/services'>Services</Link>
                            </li>
                            <li>
                                <Link to='/industries'>Industries</Link>
                            </li>
                            <li>
                                <Link to='/process'>Process</Link>
                            </li>
                            <li>
                                <Link to='/technology-stack'>Tech Stack</Link>
                            </li>
                            <li>
                                <Link to='/portfolio'>Portfolio</Link>
                            </li>
                            <li>
                                <Link to='/blog'>Blog</Link>
                            </li>
                            <li>
                                <Link to='/#reviews-section'>Reviews</Link>
                            </li>
                            <li>
                                <Link to='/#faq-section'>FAQ</Link>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <h4>Company</h4>
                        <ul>
                            <li>
                                <Link to='/company'>About DevZona</Link>
                            </li>
                            <li>
                                <Link to='/services/agentic-ai-development'>Agentic AI</Link>
                            </li>
                            <li>
                                <Link to='/services/llm-development'>LLM Development</Link>
                            </li>
                            <li>
                                <Link to='/services/mobile-app-development'>Mobile Apps</Link>
                            </li>
                            <li>
                                <a href='mailto:hamza@devzona.com'>Business Inquiries</a>
                            </li>
                            <li>
                                <a href='https://wa.me/923290992222' target='_blank' rel='noreferrer'>
                                    WhatsApp Support
                                </a>
                            </li>
                            <li>
                                <a href='https://github.com/HAMZA-420' target='_blank' rel='noreferrer'>
                                    GitHub Profile
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <h4>Legal</h4>
                        <ul>
                            <li>
                                <Link to='/privacy-policy'>
                                    Privacy Policy
                                </Link>
                            </li>
                            <li>
                                <Link to='/terms-of-use'>
                                    Terms of Use
                                </Link>
                            </li>
                            <li>
                                <Link to='/sitemap'>
                                    Sitemap
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className={Classes.divider} />

            <div className={Classes.bottomBar}>
                <p>© 2026 DevZona. All rights reserved.</p>

                <Link to='/contact-us' className={Classes.contactLink}>
                    Start Your Project
                    <KeyboardArrowRightRoundedIcon />
                </Link>
            </div>
        </footer>
    );
}
